module.exports = __webpack_public_path__ + "img/INTP.1c5314d6.png";